import { FormControl, FormGroup } from '@angular/forms';
import { ChangeDetectorRef, Component, ViewChild  } from '@angular/core';
import { NewReportService } from './new.report.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { AppService } from '../../app.service';
import { Globals } from '../../globals';
import translateJson from '../../../translate.json';
import customerJson from '../../../assets/config/customer.json';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { SearchDropdownComponent } from '../../shared/input/SearchableDropdown/search.dropdown.component'
import { Countries } from '../../shared/countries/countries';
import { MomentUtcDateAdapter } from '../../models/moment-utc-date-adapter'
import { AuthenticationService } from '../../auth';
import { KeyValue } from '@angular/common';
import { ReportTranslate } from '../../shared/enum/ReportTranslate';
import { ReportPaginator } from './paginatorIntl.service'
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Component({
    selector: 'new-report-comp',
    providers: [NewReportService, ConfirmService, AppService, Countries, MomentUtcDateAdapter, AuthenticationService, {provide: MatPaginatorIntl, useValue: ReportPaginator()}],
    templateUrl: './new.report.component.html',  
    styleUrls: ['./new.report.component.css']  
})

export class NewReportComponent{   

    @ViewChild(SearchDropdownComponent) searchDropdown: SearchDropdownComponent;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private customerSettings = customerJson.settings;
    private activeComponent: boolean;
    reportResultLimits = this.customerSettings.reportResultLimit;
    showLoader: Boolean = false;

    /* Params */
    exportFormat: any;
    generatedReports: Array<Object> = [{name: String, id: String}];
    
    /* Report */
    mainEntityList: any;
    subEntityList: any;
    criteriaList: any;
    selectedSubEntityList: any = [];
    selectedMainEntity: any;
    persistedMainEntity: any = [];
    numSelectedSub: number = 0;
    reportData: any = null;
    reportColumns: any = [];
    selectedColumns: any = [];
    numSelectedCol: number = 0;
    /* Forms */
    criteriaSearchList: any = [];
    criteriaDropdownList: any = [];
    displayProperty: any = 'id'
    currentCriteriaEdit: number = -1;
    selectedColumnsForm: FormControl
    selectedReportFilterForm: FormControl
    resultLimit: number = this.reportResultLimits[this.customerSettings.reportResultDefaultLimitIndex];

    selectedCriterias: any = [];
    previousCriterias: any = [];
    previousColumns: any = [];
    reportForm: FormGroup;
    reportSaveEditForm : FormGroup;
    i18Enum = ReportTranslate;
    currentPage: number = 1;
    lastPage: number = 1;
    pageIndex: number = 0;
    previousCriteriaLength: number = 0;
    reportFilterList : any = []
    reportName : string = null;
    selectedReportFilter: any = null;
    filterErrorMessage: any = null;
    maxFilterCriterias = this.customerSettings.maxReportFilterCriterias;
    maxNumOperators = this.customerSettings.maxReportFilterCriterias - 1;
    errorMsg: string = null;

    constructor(
        private service: NewReportService,          
        private confirmService: ConfirmService,
        private appService: AppService,
        private ngxSmartModalService: NgxSmartModalService,
        private countries: Countries,
        private momentDateAdapter: MomentUtcDateAdapter,
        private globals: Globals,
        private authService: AuthenticationService,
        private changeDetector: ChangeDetectorRef) {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('report');
            this.setDefault();

            /**
             * re calcualte the result table max-height on resize after 100ms
             */
            const windowResize = fromEvent(window, 'resize')
            windowResize
                .pipe(
                    map((i: any) => i),
                    debounceTime(100)
                ).subscribe((resizeEvent) => {
                    if(this.reportData != null) {
                        this.setResultDivHeight();
                    }
                });
    }

    /**
     * Set default values
     */
    setDefault() {
        this.exportFormat = this.service.getDefaultExportFormat();
        this.reportForm = new FormGroup({
            mainType: new FormControl(),
            subType: new FormControl(),
            searchCriteria: new FormControl(),
            selectedSearchCriteria: new FormControl(),
            countryCriteria: new FormControl(),
            textCriteria: new FormControl(),
            filterCriteria: new FormControl(),
            dateCriteria: new FormControl(),
            dropdownCriteria: new FormControl(),
            booleanCriteria: new FormControl(),
            resultLimit: new FormControl(),
            selectedReportFilterForm: new FormControl()
        });
        this.selectedColumnsForm = new FormControl;
        this.reportSaveEditForm = new FormGroup({
            oldReportName: new FormControl(),
            newReportName: new FormControl()
        });
        this.reportForm.patchValue({
            resultLimit: this.resultLimit
        });
        if(this.globals.userrole === 'ROLE_USERS' || this.globals.userrole === 'ROLE_ADMINS') {
            this.getEntityTypes();
        }
        this.getReportFilters();
    }

    /**
     * Change export format and store in a cookie
     * and the changes will remain unitl user changes again
     * @param format 
     */
    setExportFormat(format) {
        this.exportFormat = this.service.setDefaultExportFormat(format);
    }

    /**
     * Helper to open the error modal
     * @param error error string
     */
    showError(error) {
        this.showLoader = false;
        if(error === 'OK'){
            this.confirmService.error(this.i18.report.form.genericReportError);
        } else {
            this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
        }
    }


    /**
     * Prompt user with where to save the report to be downloaded
     * @param data report stream
     * @param fileName report filename
     */
    startFileDownload(data, fileName) {
        if(window.navigator.msSaveOrOpenBlob) {           
          window.navigator.msSaveBlob(data, fileName + this.getDownloadFileType());
        } else {            
          const url = window.URL.createObjectURL(data);
          const anchor = document.createElement("a");
          anchor.href = url;         
          anchor.download = fileName + this.getDownloadFileType();
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);         
        }
    } 

    /**
     * Set file ending for supported export files
     */
    getDownloadFileType() {       
        switch(this.exportFormat) {
            case 'Excel':
                return '.xlsx';
            default:
                return '.pdf';
        }
    }

    /**
     * Show the download modal with a list of available downloads
     * @param reportData report download information
     */
    showDownloadModal(reportData) {
        this.showLoader = false;
        let modalData: any = [];
        if(reportData != null) {
            this.generatedReports = reportData;
            modalData[0] = reportData[0].type;
            modalData[1] = this.generatedReports.length
        }
        this.ngxSmartModalService.setModalData(modalData, 'reportDownloadModal', true);
        this.ngxSmartModalService.getModal('reportDownloadModal').open();
    }

    /**
     * Open a download stream to download a report
     * @param reportFilter report filter object
     * @param reportName name of report
     * @param suffix file type pdf or xlsx
     */
    downloadReport(reportFilter, reportName, suffix){
        this.service.getReportStream(reportFilter, suffix)
        .subscribe(
            data => this.startFileDownload(data, reportName),
            error => this.showError(error)
        );
    }

    /**
     * Get the main entity types from backend
     * @returns entity types from backend
     */
    getEntityTypes(){
        this.service.getReportEntity().subscribe(
            data => this.setReportEntity(data),
            error => this.setErrorMsg(error)
        )
    }

    /**
     * Sets the selected main entity
     * @param data 
     */
    setReportEntity(data) {
        this.mainEntityList = data;
        this.persistedMainEntity = data
    }
    
    /**
     * Sets the selected main entity for the report
     * @param entity string
     */
    setMainEntity(entity){
        this.closePreviousOpenCriteria();
        if(this.selectedMainEntity != null && entity != null) {
            if(this.selectedMainEntity.entity != entity) {
                this.resetMatSelect();
                this.selectedSubEntityList = [];
                this.selectedColumns = [];
                this.criteriaList = [];
                this.reportColumns = [];
                this.selectedCriterias = [];
                this.reportName = null;
                this.selectedMainEntity = this.mainEntityList.find(e => e.entity === entity);
                
                this.subEntityList = this.selectedMainEntity.relationList;
                this.resetPagination();
                this.clearReportResult();
                this.getCriteriaList(entity);
                this.getReportColumns(entity);
            }
            if(this.selectedMainEntity.entity === entity) {
                this.resetPagination();
                this.clearReportResult();
            }
        } else if (this.selectedMainEntity == null && entity != null) {
                this.selectedSubEntityList = [];
                this.selectedColumns = [];
                this.criteriaList = [];
                this.reportColumns = [];
                this.selectedCriterias = [];
                this.reportName = null;
            this.selectedMainEntity = this.mainEntityList.find(e => e.entity === entity)
            this.subEntityList = this.selectedMainEntity.relationList;
            this.getCriteriaList(entity);
            this.getReportColumns(entity);
        } else {
            return;
        }
    }

    /**
     * Get all Criterias for a entity 
     * @param entity entity name
     */
    getCriteriaList(entity: string){
        this.service.getCriteriaList(entity).subscribe(
            data => this.setCriteriaList(data),
            error => this.setErrorMsg(error)
        )
    }

    /**
     * Sets criterias received from backend
     * @param data criteria data
     */
    setCriteriaList(data) {
        if(this.criteriaList === undefined || this.criteriaList === null || this.criteriaList.length === 0) {
            this.criteriaList = data;
        } else {
            if(this.criteriaList != undefined && this.criteriaList != null && data != undefined && data != null
                &&!this.criteriaList.some(present => data.some(criteria => criteria.entity === present.entity))) {
                data.forEach(element => {
                    this.criteriaList.push(element)
                });
            }
        }
    }

    /**
     * Get all columns for a entity
     * @param entity 
     */
    getReportColumns(entity: string){
        this.service.getReportColumns(entity).subscribe(
            data => this.setReportColumns(data, entity),
            error => this.setErrorMsg(error)
        )
    }

    /**
     * Sets columns received from backend
     * @param data column data
     * @param entity entity name
     */
    setReportColumns(data: any, entity: string) {
        if(this.reportColumns === undefined || this.reportColumns === null || this.reportColumns.length === 0) {
            this.reportColumns = data;
        } else {
            if(this.reportColumns != undefined && this.reportColumns != null && data != undefined && data != null
                && !this.reportColumns.some(present => data.some(col => col.entity === present.entity))) {
                data.forEach(element => {
                    this.reportColumns.push(element)
                });
            }
        }
        this.setDefaultColumns(entity, false)
    }

    /**
     * Sets selected sub entities for the report
     * and updates the list of available criterias
     * @param entity 
     */
    setSubEntity(entity: any){
        this.closePreviousOpenCriteria();
        let sel = [], tmpsel = [], prevsel = []
        let entityToAdd :any;
        this.mainEntityList.forEach(item=> { 
            if (entity.value.indexOf(item.entity) !== -1) {
                tmpsel.push(item);
                entityToAdd = item
            }       
        })
        

        for(let i=0; i < entity.value.length; i++) {      
            tmpsel.forEach(item => {        
            if (entity.value[i].indexOf(item.entity) !== -1) {
                sel.push(item);          
            }
            })
        }
        this.selectedSubEntityList.forEach(element => {
            prevsel.push(element)
        });
        this.selectedSubEntityList = [ ...sel];
        
        //get criterias and columns
        this.selectedSubEntityList.forEach(element => {
            if(!this.reportColumns.some((subEntity) => subEntity.entity === element.entity)) {
                this.getReportColumns(element.entity);
                this.getCriteriaList(element.entity)
            }
        });

        this.numSelectedSub = this.selectedSubEntityList.length - 1 < 0 ? 0 : this.selectedSubEntityList.length -1;
        this.removeCriteraColumns(entityToAdd, prevsel);
    }

    /**
     * Remove columns and criterias from lists if corresponding entity deselected
     * @param entity 
     * @param prevsel 
     */
    removeCriteraColumns(entity: any, prevsel: any) {
        if(entity === undefined){
            if(this.selectedSubEntityList != null && this.selectedSubEntityList.length == 0) {
                this.removeColumns(undefined);
                this.removeCriteriaOptions(undefined)
            }
        } else if (entity !== undefined && entity !== null 
            && this.selectedSubEntityList != null && this.selectedSubEntityList.length > 0 && prevsel.indexOf(entity) != -1) {
                // a previously selected sub-entity has been removed from the list but one or more oother is still selected
                // find the removed sub-entity by comparing the previously selected list to the current list
                prevsel.forEach(element => {
                    let inList = this.selectedSubEntityList.indexOf(element);
                    if(inList === -1) {
                        this.removeColumns(element);
                        this.removeCriteriaOptions(element);
                    }
                });
        }
    }

    /**
     * Add's a criteria to the selectedCriterias list.
     * @param criteria criteria object
     */
    addCriteria(criteria) {
        this.closePreviousOpenCriteria();
        if(this.selectedCriterias.length < (this.maxFilterCriterias + this.maxNumOperators)) {
            let found = this.selectedCriterias.indexOf(criteria);
            if(found != undefined && found != null && found > -1){
                if(criteria.inputType !== 'operators') {
                    this.addAndOrOperator();
                    //get a copy of the same previously added criteria and clear the value before adding the copy to the criteria array.
                    let criteriaToAdd = {...criteria};
                    criteriaToAdd.operator = 'eq';
                    criteriaToAdd.value = null;
                    this.selectedCriterias.push({...criteriaToAdd});
                    //to automatically open the criteria for input we have to find it in the array (due to references in memory)
                    //so we assume it will always be the last added criteria that sould be opened.
                    this.openCriteria(this.selectedCriterias.findLast((c) => c.id === criteriaToAdd.id))
                }
            } else {
                if(criteria.inputType !== 'operators') {
                    this.addAndOrOperator();
                }
                this.selectedCriterias.push(criteria);
                this.openCriteria(criteria);
            }
        }
    }

    /**
     * Opens a criteria for user input
     * @param criteria criteria object
     */
    openCriteria(criteria:any){
        this.clearCriteriaForms()
        this.closePreviousOpenCriteria();
        let found = this.selectedCriterias.indexOf(criteria);

        if(found != undefined && found != null && found > -1){
            let prevOpen = this.currentCriteriaEdit;
            this.currentCriteriaEdit = found;

            if(this.currentCriteriaEdit > -1 && prevOpen !== found && this.selectedCriterias[found] != null) {
                this.getSuggestions(criteria);
            }
            
            this.selectedCriterias[found].showInput = true;
            if(this.selectedCriterias[found].value != null && this.selectedCriterias[found].readableName != null 
                && this.selectedCriterias[found].inputType != undefined && this.selectedCriterias[found].inputType != null) {
                    this.getSuggestions(criteria)
                    let formControlName = this.getCriteriaFormByInputType(this.selectedCriterias[found].inputType)
                    this.reportForm.patchValue({
                        [formControlName]: this.selectedCriterias[found].value
                });
            }
            setTimeout(()  => this.setResultDivHeight(), 0);
        }
    }

   /**
    * Sets the report criteria filter to list 
    * @param data 
    */ 
    setFilterList(data) {
        this.criteriaSearchList = data;
    }
    
    /**
     * Set a data for a criteria dropdown 
     * @param data 
     */
    setDropdownList(data) {
        this.criteriaDropdownList = data;
    }

    /**
     * Helper to get the formControlName to use depending on criteria type
     * @param type type of criteria
     * @returns string
     */
    getCriteriaFormByInputType(type:string){
        if(type==='text') {
            return 'textCriteria';
        }
        if(type==='filter') {
            return 'filterCriteria';
        }
        if(type==='date') {
            return 'dateCriteria';
        }
        if(type==='country') {
            return 'countryCriteria';
        }
        if(type==='dropdown') {
            return 'dropdownCriteria';
        }
        if(type==='boolean') {
            return 'booleanCriteria';
        }
    }
   
    /**
     * Set criteria value from dropdown
     * @param criteria criteria obj
     * @param value value
     */
    criteriaDropdown(criteria, value){
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            this.selectedCriterias[found].value = value;
            this.lockCriteria(criteria);
        }
    }

    /**
     * Set boolean criteria value from dropdown
     * @param criteria criteria object
     * @param value boolean value
     */
    criteriaBoolean(criteria, value){
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            this.selectedCriterias[found].value = value;
            this.lockCriteria(criteria);
        }
    }

    /**
     * Remove criteria from the array by its index
     * @param index 
     */
    removeCriteria(index) {
        this.closePreviousOpenCriteria();
        this.clearCriteriaForms()
        if(this.selectedCriterias.length > 0 && index > -1) {
            //remove condition after first criteria in array
            let criteriaIndex = index;
            if(index - 1 < 0) {
                if(this.selectedCriterias[index + 1] != null && this.selectedCriterias[index + 1].inputType === 'operators') {
                    this.selectedCriterias.splice(index + 1, 1)
                }
            }
            // remove condition before any other criteria in array
            if(index - 1 > 0 && index - 1 <= this.selectedCriterias.length) {
                if(this.selectedCriterias[index - 1].inputType === 'operators') {
                    this.selectedCriterias.splice(index - 1, 1)
                    criteriaIndex = index - 1
                }
            }
            this.selectedCriterias.splice(criteriaIndex, 1)
            setTimeout(()  => this.setResultDivHeight(), 0);
        }
        //if last criteria removed reset the currentCriteria variable 
        if(this.selectedCriterias != null && this.selectedCriterias.length <= 0) {
            this.currentCriteriaEdit = -1;
        }
    }

    /**
     * Clear all criteria forms
     */
    clearCriteriaForms(){
        this.reportForm.get('searchCriteria').reset();
        this.reportForm.get('textCriteria').reset();
        this.reportForm.get('filterCriteria').reset();
        this.reportForm.get('dateCriteria').reset();
        this.reportForm.get('dropdownCriteria').reset();
        this.reportForm.get('booleanCriteria').reset();
        this.reportForm.get('countryCriteria').reset();
    }

    /**
     * Clear the report form
     */
    clearReport(){
        this.clearCriteriaForms();
        this.resetPagination();
        this.reportForm.get('mainType').reset();
        this.reportForm.get('subType').reset();
        this.reportForm.get('selectedSearchCriteria').reset();
        this.clearReportFilterForm();

        this.subEntityList = [];
        this.criteriaList = [];
        this.reportColumns = [];
        this.selectedSubEntityList = [];
        this.selectedMainEntity = [];
        this.selectedColumns = [];
        this.persistedMainEntity = [];
        this.numSelectedSub = 0;
        this.reportData = null;
        this.criteriaSearchList = [];
        this.currentCriteriaEdit = -1;
        this.selectedCriterias = [];
        this.selectedReportFilter = null;
        this.reportName = null;
        this.previousCriterias = null;
        this.previousColumns = null;
        this.clearErrorMsg();
    }

    /**
     * Clear the report data
     */
    clearReportResult() {
        this.reportData = null;
    }
    
    /**
     * Resets the pagination
     */
    resetPagination() {
        this.lastPage = 1;
        this.currentPage = 1;
        this.pageIndex = 0;
    }

    /**
     * Sets text criteria's 
     * @param criteria criteria object
     * @param value criteria value
     */
    patchCriteriaText(criteria, value) {
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1 && found === this.currentCriteriaEdit){
            this.selectedCriterias[found].value = value;
        } 
    }

    /**
     * Sets country criteria
     * @param criteria criteria object
     * @param value criteria value
     */
    patchCriteriaCountry(criteria, value) {
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            if(value == undefined || value == null){
                this.selectedCriterias[found].value = null;
            }
            if(value != undefined && value.code2 != undefined && value.name != undefined){
                this.selectedCriterias[found].value = value.code2;
            }
        }
    }

    /**
     * Locks the input for a criteria when outfocus
     * @param criteria criteria object
     */
    lockCriteria(criteria) {
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            this.selectedCriterias[found].showInput = false;
            this.currentCriteriaEdit = -1;
            this.clearCriteriaForms();
            setTimeout(()  => this.setResultDivHeight(), 0);
        }
    }

    /**
     * Helper to autocomplete a date with missing dividers '-'
     * @param date date string to patch
     * @param criteria criteria object 
     */
    patchDate(date: string, criteria: any) {
        if(date != null) {
            date = date.replace(/-/g,'');
        }
        if(date != null && date.trim() !== '' && date.length >= 8) {
            let yearPossition = 4;
            let monthPossition = 6;
            let dateDivader = '-'
            let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
            this.patchCriteriaDate(criteria, patchedDate); 
            this.reportForm.patchValue({
                dateCriteria: patchedDate
            })
        }
        if (date != null && date.trim() !== '' && date.length < 8) {
            this.clearDateCriteria(criteria)
        }
    }

    /**
     * Catches when a user picks a date using the date picker.
     * converts the Moment date to a string
     * @param value date in Moment form
     * @param criteria criteria object 
     */
    patchDatePicked(value:any, criteria: any) {
        if(value != undefined && value != null) {
            let formatedDate = this.momentDateAdapter.format(value,'');
            this.patchCriteriaDate(criteria, formatedDate); 
        } 
        if ((value == undefined || value == null) && criteria != null) {
            this.clearDateCriteria(criteria)
        }
    }

    /**
     * Sets the selected/typed date to the criteria list
     * @param criteria criteria object 
     * @param value date string
     */
    patchCriteriaDate(criteria:any, value:string){
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            this.selectedCriterias[found].value = value;
            this.lockCriteria(criteria);
        }
    }

    /**
     * Clears a dateCriteria's values in the criteria list
     * @param criteria criteria object
     */
    clearDateCriteria(criteria:any) {
        let found = this.selectedCriterias.indexOf(criteria);
        if(found != undefined && found != null && found > -1){
            this.selectedCriterias[found].value = null;
        }
    }

    /**
     * Send the specified report filter to backend to generate report preview
     */
    applyFilter(){
        this.clearErrorMsg();
        this.showLoader = true;
        if(this.selectedMainEntity == undefined || this.selectedMainEntity == null) {
            this.showLoader = false;
            return;
        }
        // if the result limit have changed between pagination or filter queries
        // reset current page for the pagination
        if(this.reportData != null && this.reportData.resultLimit != null
            && this.resultLimit != this.reportData.resultLimit) {
                this.currentPage = 1;
                this.pageIndex = 0;
        }
        if(this.previousColumns != null && this.selectedColumns != null
            && this.selectedColumns.length != this.previousColumns.length) {
                this.currentPage = 1;
                this.pageIndex = 0;
        }
        // if a there is a previous report result and a sub entity is deselected
        // reset pagination to avoid seenig empty result due to beeing on a page that does not exist.
        if(this.reportData != null && this.reportData.reportColumnsList != null &&
            this.selectedSubEntityList != null && this.selectedSubEntityList.length > 0) {
                let hasRemovedSubEntity = false;
                this.reportData.reportColumnsList.forEach(element => {
                    if(element.entity !== this.selectedMainEntity.entity && element.parent === null) {
                        let foundRemoved = this.selectedSubEntityList.some(subEntity => subEntity.entity === element.entity)
                        if(!foundRemoved && !hasRemovedSubEntity) {
                            hasRemovedSubEntity = true;
                            this.currentPage = 1;
                            this.pageIndex = 0;
                        }
                    }
                })
        }
        // if a filter criteria has been added or removed since last query
        // reset pagination.
        if(this.reportData != null && this.previousCriterias != null && this.previousCriterias.length > 0) {
            if(this.selectedCriterias != null && this.selectedCriterias.length > 0) {
                if(this.selectedCriterias.length != this.previousCriterias.length){
                    this.currentPage = 1;
                    this.pageIndex = 0;

                } else {
                    this.selectedCriterias.forEach((criteria, index) => {
                        if(this.previousCriterias[index] != undefined && this.previousCriterias[index] != null) {
                            if(criteria.operator !== 'operators') {
                                let prevEntity = this.previousCriterias[index].entity;
                                let prevSearchKey = this.previousCriterias[index].searchKey;
                                let prevValue = this.previousCriterias[index].value;
                                let prevOperator = this.previousCriterias[index].operator;
                                if(criteria.entity !== prevEntity 
                                    || criteria.searchKey !== prevSearchKey 
                                    || criteria.value !== prevValue 
                                    || criteria.operator != prevOperator) {
                                    this.currentPage = 1;
                                    this.pageIndex = 0;
                                } 
                            } else {
                                let andOrValue = this.previousCriterias[index].value;
                                if(criteria.value !== andOrValue) {
                                    this.currentPage = 1;
                                    this.pageIndex = 0;
                                }
                            }
                        } else {
                            this.currentPage = 1;
                            this.pageIndex = 0;
                        }

                    });
                }

            } else {
                this.currentPage = 1;
                this.pageIndex = 0;
            }
        } else if(this.selectedCriterias !== null && this.selectedCriterias.length > 0 && this.previousCriterias === null) {
            //previous filter was without criterias new filter has criterias
            this.currentPage = 1;
            this.pageIndex = 0;
        }
        
        this.previousCriterias = this.selectedCriterias != null && this.selectedCriterias.length > 0 ? this.selectedCriterias.map(criteria => ({...criteria})) : null;
        this.previousColumns = this.selectedColumns != null ? this.selectedColumns.map(col => ({...col})) : null;
        let mainEntity = {
            id: this.selectedMainEntity.id,
            entity: this.selectedMainEntity.entity,
            i18: this.selectedMainEntity.i18,
            readableName: this.selectedMainEntity.readableName,
            relationList: this.selectedMainEntity.relationList,
            subEntities: this.selectedSubEntityList
        }
        
        let report = {
            reportName: this.reportName,
            mainEntity: mainEntity,
            orderByList: [],
            criteriaList: this.selectedCriterias,
            reportColumnList: this.selectedColumns,
            resultLimit: this.resultLimit,
            currentPage: this.currentPage
        }
        
        this.service.generateReportPreview(report).subscribe(
            data => {
                if(data.status != undefined && data.status != null && data.status == 200) {
                    this.setErrorMsg(data.message);
                    this.clearReportResult();
                    this.resetPagination();
                } else {
                    this.viewReport(data)
                }
            },
            error => this.setErrorMsg(error)
        )
    }

    /**
     * Set report data to be viewed
     * @param data 
     */
    viewReport(data){
        this.showLoader = false;
        this.reportData = data;
        this.currentPage = data.currentPage;
        this.lastPage = data.totalPages;
        this.pageIndex = data.currentPage-1;
        this.previousCriteriaLength = this.selectedCriterias != null ? this.selectedCriterias.length : 0; 
        setTimeout(()  => this.setResultDivHeight(), 0);
        if(this.paginator != undefined && this.paginator.pageIndex != undefined) {
            this.paginator.pageIndex = this.pageIndex;
        }
    }

    /**
     * helper ensure the correct order of the report map
     */
    originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
        return 0;
    }
    
    /**
     * Updates the selected columns list on user input
     * @param entity 
     */
    setColumns(entity: any){
        let sel = [], tmpsel = [], prevsel = []
        this.reportColumns.forEach(item=> {
            item.columnList.forEach(col => {
                let tmpPos = entity.value.indexOf(col);
                if (tmpPos !== -1) {
                    tmpsel.push(entity.value[tmpPos]);
                }

            })
        })

        tmpsel.forEach(item => {
            if (entity.value.indexOf(item) !== -1) {
                sel.push(item);
            }
        })
        this.selectedColumns = [ ...sel];
        this.numSelectedCol = this.selectedColumns.length;
    }

    /**
     * Set's the selected columns list with default columns when a entity is selected
     * @param entityStr entity name
     * @param ignoreDefaults 
     */
    setDefaultColumns(entityStr:string, ignoreDefaults: boolean) {
        if(entityStr !== undefined && entityStr !== null) {
            for(let entity of this.reportColumns) {
                if(entity.entity === entityStr) {
                    for(let col of entity.columnList) {
                        if(!ignoreDefaults && this.selectedColumns.indexOf(col) == -1 && col.showDefault) {
                            this.selectedColumns.push(col)
                        }
                    }
                }
            }

        }
        this.setColumns({value: this.selectedColumns});
        this.selectedColumnsForm.setValue(this.selectedColumns)
    }

    /**
     * Remove criterias from the criteriaList for a deselected entity
     * @param entity entity obj
     */
    removeCriteriaOptions(entity:any) {
        if(entity === undefined && this.selectedSubEntityList.length === 0) {
            let mainEntity = this.selectedMainEntity.entity;
            //remove selected criterias that is not mainEntity
            while(this.selectedCriterias.findIndex((c) => c.operator !== 'operators' && (c.entity !== mainEntity || (c.parent != null && c.parent !== mainEntity))) > -1) {
                this.removeCriteria(this.selectedCriterias.findIndex((c) => c.operator !== 'operators' && (c.entity !== mainEntity || (c.parent != null && c.parent !== mainEntity))))
            }
            // remove from list of available report criterias to choose from
            this.criteriaList.forEach((item, index) => {
                if(item.entity !== mainEntity) {
                    this.criteriaList.splice(index, 1);
                }
            })
        } else {
            // remove selected criterias for the entity
            while(this.selectedCriterias.findIndex((c) => c.operator !== 'operators' && (c.entity === entity.entity || (c.parent != null && c.parent === entity.entity))) > -1) {
                this.removeCriteria(this.selectedCriterias.findIndex((c) => c.operator !== 'operators' && (c.entity === entity.entity || (c.parent != null && c.parent === entity.entity))))
            }
            this.criteriaList.forEach( (item, index) => {
                if(item.entity === entity.entity){
                    item.criteriaList.forEach(element => {
                    })
                    // remove from list of available report criterias to choose from
                    this.criteriaList.splice(index, 1);
                }
            });
        }
    }

    /**
     * Removes columns for the entity that has been deselected
     * @param entity entity
     */
    removeColumns(entity:any) {
        if(entity === undefined && this.selectedSubEntityList.length === 0) {
            let mainEntity = this.selectedMainEntity.entity;
            // call the remove loop two times to remove last element.
            this.removeAvailableColumns(mainEntity);
            this.removeAvailableColumns(mainEntity);
            // remove from list of available report columns to choose from
            this.reportColumns.forEach((item, index) => {
                if(item.entity !== mainEntity) {
                    this.reportColumns.splice(index, 1);
                }
            })
        } else {
            this.reportColumns.forEach( (item, index) => {
                if(item.entity === entity.entity){
                    item.columnList.forEach(element => {
                        this.selectedColumns.forEach((col, colIndex) => {
                            if(element === col) {
                                // remove entities selected columns
                                this.selectedColumns.splice(colIndex, 1);
                            }
                        })
                    })
                    // remove from list of available report columns to choose from
                    this.reportColumns.splice(index, 1);
                }
            });
        }
        this.setDefaultColumns(entity, true);
    }

    /**
     * Removes all selected columns for a entity
     * @param mainEntity entity
     */
    removeAvailableColumns(mainEntity: string) {
        this.selectedColumns.forEach((col, index) => {
            if((col.entity !== undefined && col.entity !== null && col.entity !== mainEntity)
                || (col.parent !== undefined && col.parent !== null && col.parent !== mainEntity)) {
                this.selectedColumns.splice(index, 1);
            }
        })
    }

    /**
     * Removes all selected criterias when a sub entity is deselected
     * @param mainEntity entity
     */
    removeAvailableCriterias(mainEntity: string) {
        this.selectedCriterias.forEach((criteria, index) => {
            if(criteria.entity !== mainEntity && criteria.operator !== 'operators') {
                this.removeCriteria(index)
            }
        })
    }

    /**
     * helper to change the criteria operator
     * @param index criteria index
     * @param newOperator operator to use
     */
    changeOperator(index, newOperator) {
        if(this.selectedCriterias[index] !== null) {
            this.selectedCriterias[index].operator = newOperator
        }
    }

    /**
     * Updates a reports results per page and queries for new report result.
     * @param value result limit
     */
    setNewResultLimit(value: number) {
        this.resultLimit = +value; // +value to ensure number and not string
        this.applyFilter();
    }

    /**
     * Changes the report preview page to view and queries for new report result
     * @param pageEvent pagination PageEvent
     */
    setPaginationPage(pageEvent: PageEvent) {
        this.currentPage = pageEvent.pageIndex + 1
        this.applyFilter();
    }

    /**
    * Fills list with suggestions for "filter" and "dropdown"
    * @param criteria criteria object
    */
    getSuggestions(criteria: any) {
        if(criteria.inputType ==='filter'){
            this.service.getCriteriaSuggestions(criteria.entity, criteria.searchKey)
            .subscribe(
                data => {
                    this.setFilterList(data);
                },
                error => this.setErrorMsg(error)
            )
        } else if (criteria.inputType === 'dropdown') {
            this.service.getDropdownOptions(criteria.entity, criteria.searchKey)
            .subscribe(
                data => {
                    this.setDropdownList(data);
                },
                error => this.setErrorMsg(error)
            )
        }
    }

    /**
     * Helper to close the open input modal.
     * Used when switching between criterias or addning new criterias or entities
     * to avoid unclosable criterias
     */
    closePreviousOpenCriteria(){
        if(this.currentCriteriaEdit > -1 && this.selectedCriterias[this.currentCriteriaEdit] != undefined && this.selectedCriterias[this.currentCriteriaEdit] != null){
            this.selectedCriterias[this.currentCriteriaEdit].showInput = false;
            setTimeout(()  => this.setResultDivHeight(), 0);
        }
    }

    /**
     * Send current report query to backend to download report result.
     */
    genReportFiles() {
        this.showLoader = true;
        let mainEntity = {
            id: this.selectedMainEntity.id,
            entity: this.selectedMainEntity.entity,
            i18: this.selectedMainEntity.i18,
            readableName: this.selectedMainEntity.readableName,
            relationList: this.selectedMainEntity.relationList,
            subEntities: this.selectedSubEntityList
        }

        let report = {
            reportName: this.reportName, 
            exportType: this.exportFormat,
            mainEntity: mainEntity,
            criteriaList: this.selectedCriterias,
            orderByList: [],
            reportColumnList: this.selectedColumns
        }

        this.service.generateReport(report).subscribe(
            data => this.showDownloadModal(data),
            error => this.showError(error),
            () => this.showLoader = false
        )
    }

    /**
     * Helper to change the AND/OR operator
     * @param index array index of operator
     * @param newOperator new operator to set
     */
    changeAndOrOperator(index, newOperator) {
        if(this.selectedCriterias[index] !== null) {
            if(newOperator === 'and'){
                let condition = {
                    operator: 'operators',
                    searchKey: 'operators',
                    i18: 'i18.report.form.filterAndLabel',
                    readableName: this.i18.report.form.filterAndLabel,
                    showInput: false,
                    inputType: 'operators',
                    value: 'AND'
                }
                this.selectedCriterias[index] = condition;
            }
            if(newOperator === 'or') {
                let condition = {
                    operator: 'operators',
                    searchKey: 'operators',
                    i18: 'i18.report.form.filterOrLabel',
                    readableName: this.i18.report.form.filterOrLabel,
                    showInput: false,
                    inputType: 'operators',
                    value: 'OR'
                }
                this.selectedCriterias[index] = condition;
            }
        }
    }

    /**
     * Helper to add AND/OR operator to the criteria array
     * when adding a filter criteria
     */
    addAndOrOperator(){
        if(this.selectedCriterias.length > 0){
            let condition = {
                operator: 'operators',
                searchKey: 'operators',
                readableName: this.i18.report.form.filterAndLabel,
                showInput: false,
                inputType: 'operators',
                value: 'AND'
            }
            this.selectedCriterias.push({...condition})
        }
    }

    /**
     * Applies a selected report filter with entities and criterias
     * @param filter report filter object
     */
    patchReportFilter(filter: any) {
        if (filter !== undefined && filter !== null) {
            this.clearFilter()
            this.selectedCriterias = [];
            this.selectedReportFilter = filter;
            let report = JSON.parse(filter.reportFilter);
            this.setMainEntity(report.mainEntity.entity);
            this.reportForm.patchValue({
                mainType: report.mainEntity.entity
            });
            this.reportName = filter.reportName;
            this.resetMatSelect();
            if(report.mainEntity.subEntities != undefined && report.mainEntity.subEntities != null && report.mainEntity.subEntities.length > 0) {
                let subList = [];
                report.mainEntity.subEntities.forEach(sub => {
                    subList.push(sub.entity);
                });
                let fakeMatObject = {
                    source: null,
                    value: subList
                }
                this.setSubEntity(fakeMatObject);
                this.reportForm.patchValue({subType: subList});
            }

            if(report.reportFilter != null && report.reportFilter.length > 0) {
                report.reportFilter.forEach(criteria => {
                    this.addSavedCriteria(criteria)
                });
            }
        } else {
            this.selectedReportFilter = null;
        }
        this.changeDetector.detectChanges();
    }

    /**
     * Helper to reset the mat-select dropdown used for subEntities
     * when changing main entity or selecting a saved filter
     */
    resetMatSelect() {
        let fakeMatObject = {
            source: null,
            value: []
        }
        this.setSubEntity(fakeMatObject);
        this.reportForm.patchValue({subType: []});
    }

    /**
     * Get report filters from backend.
     */
    getReportFilters() {
        this.service.getReportFilters()
        .subscribe(
            data => {
                this.setReportFilters(data);
            },
            error => this.showError(error)
        )
    }

    /**
     * Sets the report filterlist.
     * @param data list of report filters
     */
    setReportFilters(data: any) {
        this.reportFilterList = data;
    }

    /**
     * Open filter save/edit modaö
     */
    openSaveEditModal() {
        let type = null;
        let filterName = this.reportForm.get('selectedReportFilterForm').value;
        if(this.selectedReportFilter !== null && filterName !== null
            && this.selectedReportFilter.reportName === filterName) {
                type = 'edit';
                this.reportSaveEditForm.patchValue({
                    oldReportName: this.selectedReportFilter.reportName,
                    newReportName: this.selectedReportFilter.reportName
                });
        }
        if(this.selectedReportFilter == null || filterName == null || filterName === '') {
            type = 'save';
        }
        this.ngxSmartModalService.setModalData(type, 'saveEditModal', true);
        this.ngxSmartModalService.getModal('saveEditModal').open();
    }

    /**
     * Close filter save/edit modal
     */
    closeSaveEditModal() {
        this.filterErrorMessage = null;
        this.reportSaveEditForm.reset();
        this.ngxSmartModalService.getModal('saveEditModal').close();
    }

    /**
     * Helper to call the correct filter operation from the filter save/update modal
     * @param type save or edit
     */
    applySaveEdit(type) {
        if(type === 'save') {
            this.saveReportFilter(this.reportSaveEditForm.get('newReportName').value);
        }
        if(type === 'edit') {
            this.updateReportFilter(this.reportSaveEditForm.get('newReportName').value)
        }
    }

    /**
     * Save a report filter
     * @param nameToSave name of report filter.
     */
    saveReportFilter(nameToSave: string) {
        this.filterErrorMessage = null;
        this.showLoader = true;
        let entity = {
            id: this.selectedMainEntity.id,
            entity: this.selectedMainEntity.entity,
            i18: this.selectedMainEntity.i18,
            readableName: this.selectedMainEntity.readableName,
            subEntities: this.selectedSubEntityList
        }
        let tmp = {
            mainEntity: entity,
            reportFilter: this.selectedCriterias
        }
        let filter = {
            reportName: nameToSave,
            reportFilter: JSON.stringify(tmp)
        }
        this.service.saveReportFilter(filter)
        .subscribe(
            data => {
                this.setReportFilters(data);
                let savedFilter = data.find(f => f.reportName === filter.reportName);
                if(savedFilter !== undefined && savedFilter !== null) {
                    this.reportForm.patchValue({
                        selectedReportFilterForm: savedFilter.reportName
                    })
                    this.patchReportFilter(savedFilter);
                }
                this.closeSaveEditModal();
            },
            error => this.setReportFilterError(error),
            () => this.showLoader = false
        );
    }

    /**
     * Sets the error prompt in the save/update modal and displays it to the user
     * @param error error message from backend
     */
    setReportFilterError(error) {
        this.showLoader = false
        this.filterErrorMessage = this.appService.getTranslatedErrorMessage(error);
    }

    /**
     * Update a previously saved report
     * @param report report obj
     */
    updateReportFilter(newReportName){
        this.filterErrorMessage = null;
        this.showLoader = true;
        let oldFilter = this.selectedReportFilter;

        let entity = {
            id: this.selectedMainEntity.id,
            entity: this.selectedMainEntity.entity,
            i18: this.selectedMainEntity.i18,
            readableName: this.selectedMainEntity.readableName,
            subEntities: this.selectedSubEntityList
        }
        let tmp = {
            mainEntity: entity,
            reportFilter: this.selectedCriterias
        }
        let filter = {
            id: oldFilter.id,
            reportName: newReportName,
            reportFilter: JSON.stringify(tmp)
        }
        this.service.updateReportFilter(filter)
        .subscribe(
            data => {
                if(!data.some(filter => filter.reportName === oldFilter.reportName)) {
                    let updatedFilter = data.find(f => f.reportName === filter.reportName);
                    if(updatedFilter !== undefined && updatedFilter !== null) {
                        this.reportForm.patchValue({
                            selectedReportFilterForm: updatedFilter.reportName
                        })
                    }
                    this.patchReportFilter(updatedFilter);
                }
                this.setReportFilters(data)
                this.closeSaveEditModal();
            },
            error => {
                this.setReportFilterError(error);
            },
            () => this.showLoader = false
        );
    }

    /**
     * Delete a saved report filter.
     * @param filterName name of filter to delete
     */
    deleteFilter(filterName) {
        this.filterErrorMessage = null;
        if(this.selectedReportFilter.reportName === filterName) {
            this.confirmService.confirmHtml(`${this.i18.report.modal.filterDeleteDescriptionLabelPrefix}${filterName}${this.i18.report.modal.filterDeleteDescriptionLabelSuffix}`, `${this.i18.report.modal.filterButtonDelete}`, `${this.i18.report.modal.filterButtonCancel}`)
            .then(doDelete => {
                if(doDelete){
                    this.showLoader = true;
                    this.service.deleteReportFilter(this.selectedReportFilter.id)
                    .subscribe(
                        data => {
                            this.clearReportFilterForm();
                            this.clearReport();
                            this.setReportFilters(data);
                        },
                        error => this.setReportFilterError(error),
                        () => this.showLoader = false
                    );
                }
            })
        }
    }

    /**
     * Set route on click
     * @param routerLink route name
     * @param active if the route is active
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

    /**
     * reset the report filter form
     */
    clearReportFilterForm() {
        this.reportForm.get('selectedReportFilterForm').reset();
    }

    /**
     * sets a error message
     * @param error error 
     */
    setErrorMsg(error) {
        this.showLoader = false;
        if(error === 'OK'){
            this.errorMsg = this.i18.report.form.genericReportError;
        } else {
            this.errorMsg = this.appService.getTranslatedErrorMessage(error);
        }
    }

    /**
     * clear error message
     */
    clearErrorMsg() {
        this.errorMsg = null;
        setTimeout(()  => this.setResultDivHeight(), 0);
    }
    
    /**
     * Add's a criteria to the selectedCriterias list.
     * @param criteria criteria object
     */
    addSavedCriteria(criteria) {
        this.closePreviousOpenCriteria();
        if(this.selectedCriterias.length < (this.maxFilterCriterias + this.maxNumOperators)) {
            let found = this.selectedCriterias.indexOf(criteria);
            if(found != undefined && found != null && found > -1){
                if(criteria.inputType !== 'operators') {
                    //get a copy of the same previously added criteria and clear the value before adding the copy to the criteria array.
                    let criteriaToAdd = {...criteria};
                    criteriaToAdd.operator = 'eq';
                    criteriaToAdd.value = null;
                    this.selectedCriterias.push({...criteriaToAdd});
                    //to automatically open the criteria for input we have to find it in the array (due to references in memory)
                    //so we assume it will always be the last added criteria that sould be opened.
                    this.openCriteria(this.selectedCriterias.findLast((c) => c.id === criteriaToAdd.id))
                }
            } else {
                this.selectedCriterias.push(criteria);
                //dont open and/or operator criterias
                if(criteria.inputType !== 'operators') {
                    this.openCriteria(criteria);
                }
            }
        }
    }

    /**
     * clear the report filter form when switching between filters
     */
    clearFilter() {
        this.clearCriteriaForms();
        this.resetPagination();
        this.reportForm.get('mainType').reset();
        this.reportForm.get('subType').reset();
        this.reportForm.get('selectedSearchCriteria').reset();

        this.subEntityList = [];
        this.criteriaList = [];
        this.reportColumns = [];
        this.selectedSubEntityList = [];
        this.selectedMainEntity = [];
        this.selectedColumns = [];
        this.persistedMainEntity = [];
        this.numSelectedSub = 0;
        this.reportData = null;
        this.criteriaSearchList = [];
        this.currentCriteriaEdit = -1;
        this.selectedCriterias = [];
        this.clearErrorMsg();

    }

    /**
     * Helper to set the correct height of the resultData table
     */
    setResultDivHeight() {
        if(this.reportData != null) {
            /* get the size of present div's
            * if null use size for 1920x1080 resolution with no criterias selected.
            */
            let reportHeaderDiv = document.getElementById('report-header-div') != null ? document.getElementById('report-header-div').offsetHeight: 69;
            let criteriaDiv = document.getElementById('criteria-div') != null ? document.getElementById('criteria-div').offsetHeight : 149;
            let columnDiv = document.getElementById('column-div') != null ? document.getElementById('column-div').offsetHeight : 74;
            let siteHeader = document.getElementById('site-header') != null ? document.getElementById('site-header').offsetHeight: 52;
            let reportPaginationDiv = document.getElementById('reportPagination').offsetHeight > 0 ? document.getElementById('reportPagination').offsetHeight : 56

            //calculate total div size
            let otherDivSize = reportHeaderDiv + criteriaDiv + columnDiv + siteHeader + reportPaginationDiv;

            // add size if alerts or criterias are open.
            if(this.selectedCriterias !== null && this.selectedCriterias.length == (this.maxFilterCriterias + this.maxNumOperators)) {
                otherDivSize + 10;
            }
            if(this.errorMsg != null) {
                otherDivSize + 10;
            }
            if(this.selectedCriterias != null && this.selectedCriterias.some((cr) => cr.showInput === true)) {
                otherDivSize + 30;
            }
            let size = (window.innerHeight - otherDivSize) - 30 + 'px'
            //set the size to the element
            if(document.getElementById('preview-div') != null) {
                document.getElementById('preview-div').style.maxHeight = size;
            }
        }
    }
}